module.exports = __webpack_public_path__ + "d69924b98acd849cdeba9fbff3f88ea6.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-300italic.woff2
// module id = 661
// module chunks = 0